(function () {
  function initRecommendations(section) {
    var url = section.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var sourceGrid = html.querySelector('[data-recommendations-grid]');
        var targetGrid = section.querySelector('[data-recommendations-grid]');
        if (!sourceGrid || !targetGrid || sourceGrid.children.length === 0) {
          section.remove();
          return;
        }
        targetGrid.innerHTML = sourceGrid.innerHTML;
        section.removeAttribute('hidden');
      })
      .catch(function () {
        section.remove();
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-recommendations-section]').forEach(initRecommendations);
  });
})();
